import { c as _c } from "react/compiler-runtime";
import type { ToolUIPart } from 'ai';
import { GeneratedFilesList } from './process-files-tool';
interface ToolInvocationPart {
  type: string;
  state?: string;
  toolCallId?: string;
  output?: {
    generatedFileUuids?: string[];
  };
}
interface FillSl2FormToolProps {
  part: ToolUIPart;
}

/**
 * Component for rendering fillSl2Form tool output.
 */
export function FillSl2FormTool(t0) {
  const $ = _c(4);
  const {
    part
  } = t0;
  if (part.state === "output-available" && (part as ToolInvocationPart).output) {
    const output = (part as ToolInvocationPart).output;
    if (output.generatedFileUuids) {
      let t1;
      if ($[0] !== output.generatedFileUuids) {
        t1 = output.generatedFileUuids.map(_temp);
        $[0] = output.generatedFileUuids;
        $[1] = t1;
      } else {
        t1 = $[1];
      }
      let t2;
      if ($[2] !== t1) {
        t2 = <GeneratedFilesList files={t1} />;
        $[2] = t1;
        $[3] = t2;
      } else {
        t2 = $[3];
      }
      return t2;
    }
  }
  return null;
}
function _temp(uuid, idx) {
  return {
    uuid,
    filename: `SL2 form ${idx + 1}.pdf`
  };
}